export default __webpack_public_path__ + "static/media/Mark-5-Suit-00.98a5907e.jpg";